/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./About.css";
import aboutImg from "../../images/about-img.jpg";

const About = () => {
  return (
    <div className="about-area my-5 pt-5" id="about-section">
      <Container>
        <Row className="px-3">
          <Col xs={12} md={12} lg={6}>
            <div className="about-img">
              <img src={aboutImg} alt="" />
              <div className="info-detail">
                <span>😊 Name</span>
                <h5>MD Mehedi Hasan</h5>
                <p>----------------------------</p>
                <span>🎂 Birthday</span>
                <h5>26 Oct 2000</h5>
                <p>----------------------------</p>
                <span>📞 Phone</span>
                <h5>+880181-1125173</h5>
                <p>----------------------------</p>
                <span>🏠 Address</span>
                <h5>Chittagong, Bangladesh</h5>
              </div>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <h5 style={{ color: "#e74c3c", fontWeight: "bold" }}>About me!</h5>
            <h4 className="title">Frontend Engineer at Reef 🚀</h4>
            <p
              className="para"
              style={{ color: "#000", fontSize: "15px", textAlign: "left" }}
            >
              👋 Hello, I'm MD Mehedi Hasan, a dedicated Frontend Developer
              based in Singapore, currently thriving in the dynamic team at
              Reef.
              <br /><br /> 🔧 With a laser focus on Frontend development, I specialize
              in crafting elegant, user-friendly interfaces using the power of
              React.js and the versatility of Next.js. I'm on a mission to turn
              ideas into digital experiences, and I love every pixel of it.
              <br /><br /> 📌 My career goal is crystal clear: I aspire to become a
              Frontend Expert, continuously honing my skills and staying on the
              forefront of the ever-evolving web technologies. As the digital
              landscape transforms, I'm excited to embrace and master the latest
              tools, trends, and frameworks in the world of Frontend
              development.
            </p>
            <div className="resume-div pt-2">
              <a
                target="_blank"
                href="https://drive.google.com/file/d/1KsR0LryLLUmPsnYDjtdznkUJQT6PENTA/view?usp=sharing"
              >
                <i className="fas fa-download"></i> Download Resume
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;
